import '@babel/polyfill'
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import './plugins/axios'
import axios from 'axios'
import App from './App'
import store from './store/store'
import './pushHelper'
import './registerServiceWorker'
import router from './router'
import IdleVue from 'idle-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

// Lazy load Vuetify components using vuetify-loader
import Vuetify from 'vuetify/lib'
import { Touch, Ripple } from 'vuetify/lib/directives'
// import 'vuetify/src/stylus/app.styl'

// if (!global.Intl) {
//   require.ensure([
//     'intl',
//     'intl/locale-data/jsonp/en.js'
//   ], function (require) {
//     require('intl')
//     require('intl/locale-data/jsonp/en.js')
//   })
// }
require('intersection-observer')

Vue.use(Vuetify, {
  directives: {
    Touch,
    Ripple
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-130544460-1',
  router
})

const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}

Vue.use(VueSweetalert2, options)

Vue.use(require('vue-moment'))

Vue.config.productionTip = false
// Vue.config.devtools = true // enables devtools in production mode

Vue.prototype.$http = Vue.axios

axios.defaults.baseURL = 'https://www.atschool.co.nz/api/v2'

const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 180000, // 3 minutes
  startAtIdle: false
})

const opts = {
  directives: {
    Touch,
    Ripple
  }
}

new Vue({
  vuetify: new Vuetify(opts),
  store,
  router,
  render: h => h(App)
}).$mount('#app')
